import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';
import { SessionService } from '@services/utils/session.service';

import { dayjs, toDayjsLocale } from '@helpers/dayjs.setup';
import { appDependencies } from './app.dependencies';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [appDependencies]
})
export class AppComponent {
    private readonly internationalizationService = inject(InternationalizationService);
    private readonly translate = inject(TranslateService);
    private readonly sessionService = inject(SessionService);
    private readonly router = inject(Router);

    readonly isVisibleGoogleTranslate$ = this.sessionService.isVisibleGoogleTranslate;

    constructor() {
        this.initLocales();
        this.clearChunkFailFlagOnFirstNavigation();
    }

    private initLocales(): void {
        dayjs.locale(toDayjsLocale(this.internationalizationService.getLanguage()));
        this.translate.setDefaultLang(this.internationalizationService.getLanguage());
        this.translate.use(this.internationalizationService.getLanguage());
    }

    private clearChunkFailFlagOnFirstNavigation(): void {
        this.router.events.pipe(first((event) => event instanceof NavigationEnd)).subscribe(() => sessionStorage.removeItem('redirectOnChunkFail'));
    }
}
